import { t } from "i18next";
import * as yup from "yup";

export const inventoryManagerSchema = yup.object({
  id: yup.string().nullable(),
  firstname: yup.string().required(t("First name is requited")),
  lastname: yup.string().required(t("Last name is requited")),
  phoneNumber: yup
    .string()
    .required(t("Phone number is requited"))
    .min(13, t("Please use the format +225 XX XXXXXXXX for the phone number.")),
  password: yup
    .string()
    .when("id", {
      is: undefined,
      then: () =>
        yup
          .string()
          .required(t("Password is requited"))
          .min(8, t("Password must be at least 8 characters long"))
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&-:^#]{8,}$/,
            t(
              "Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character."
            )
          )
    })
    .test("min", t("Password must be at least 8 characters long"), (value) =>
      value ? value.length >= 8 : true
    )
    .test(
      "match",
      t(
        "Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character."
      ),
      (value) =>
        value
          ? /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&-:^#]{8,}$/.test(
              value
            )
          : true
    ),

  repeatPassword: yup
    .string()
    .oneOf([yup.ref("password")], t("Passwords must match"))
});
